import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2924399a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("メンバー管理")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("削除")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("元に戻す")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, { data: _ctx.projects }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "name",
        label: "プロジェクト名"
      }),
      _createVNode(_component_el_table_column, {
        align: "right",
        label: ""
      }, {
        default: _withCtx((scope) => [
          (scope.row.deleted_flg == false)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "row-button",
                onClick: ($event: any) => (_ctx.handleEdit(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (scope.row.deleted_flg == false)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "row-button button-link",
                to: { name: 'ProjectUsers', params: { project_id: scope.row.id } }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true),
          (scope.row.deleted_flg == false)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                class: "row-button",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleDelete(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (scope.row.deleted_flg == true)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "primary",
                onClick: ($event: any) => (_ctx.handleRestoration(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}